import AnimationDelay from '../utils/AnimationDelay';
import swap from '../utils/swap';

const getOneIdx = (a, i, radix) => {
  let j = i;
  for (j = i; j < a.length; j += 1) {
    if (a[j] & radix) {
      return j;
    }
  }
  return j
}
const getZeroIdx = (a, i, radix) => {
  let j = i;
  for (j = i; j < a.length; j += 1) {
    if ((a[j] & radix) === 0) {
      return j;
    }
  }
  return j;
}
const radixsort = async (a, delayController) => {
  return new Promise(async (resolve) => {
    const digits = [1,2,4,8,16,32,64,128, 256];
    for (let j = 0; j < digits.length; j +=1) {
      await delayController.delay();
      const bucket = {
        0:[],
        1:[],
      };
      const radix = digits[j];
      for (let i = 0; i < a.length; i += 1) {
        await delayController.delay();
        if (a[i] & radix) {
          bucket[1].push(a[i])
        } else {
          bucket[0].push(a[i]);
        }
      }
      for (let i = 0; i < bucket[0].length; i += 1) {
        await delayController.delay();
        a[i] = bucket[0][i]
      }
      for (let i = 0; i < bucket[1].length; i += 1) {
        await delayController.delay();
        a[i + bucket[0].length] = bucket[1][i]
      }
    }
    resolve();
  })
};
export default class BubbleSortAlgorithm {
  constructor({delayController} = {}) {
    this.delayController = delayController || new AnimationDelay();
  }
  sort = async (a) => {
    await radixsort(a, this.delayController)
  }
}



// WEBPACK FOOTER //
// ./src/algorithms/radixsort.js